const datasetSharingActions = {
  ADD_DATASET_MEMBERS: 'ADD_DATASET_MEMBERS',
  FETCH_DATASET_MEMBERS: 'FETCH_DATASET_MEMBERS',
  FETCH_DATASET_PERMISSIONS: 'FETCH_DATASET_PERMISSIONS',
  HIDE_SHARE_DATASET: 'HIDE_SHARE_DATASET',
  REMOVE_DATASET_MEMBER: 'REMOVE_DATASET_MEMBER',
  SHARE_DATASET: 'SHARE_DATASET',
  SHARE_DATASET_ERROR: 'SHARE_DATASET_ERROR',
  SHARE_DATASET_SUCCESS: 'SHARE_DATASET_SUCCESS',
  SHOW_DATASET_MEMBERS: 'SHOW_DATASET_MEMBERS',
  SHOW_DATASET_MEMBERS_ERROR: 'SHOW_DATASET_MEMBERS_ERROR',
  SHOW_DATASET_PERMISSIONS: 'SHOW_DATASET_PERMISSIONS',
  SHOW_DATASET_PERMISSIONS_ERROR: 'SHOW_DATASET_PERMISSIONS_ERROR',
  SHOW_SHARE_DATASET: 'SHOW_SHARE_DATASET',
  UPDATE_DATASET_MEMBER_PERMISSIONS: 'UPDATE_DATASET_MEMBER_PERMISSIONS',
  UPDATE_SHARE_DATASET_PROPERTIES: 'UPDATE_SHARE_DATASET_PROPERTIES',
  UPDATE_DATASET_MEMBERS_PROPERTIES: 'UPDATE_DATASET_MEMBERS_PROPERTIES',
};

const datasetSharingPermissions = {
  INVITE_MEMBER: 'can_invite_user',
  REMOVE_MEMBER: 'can_remove_user',
  SECURITY: 'can_manage_perms',
};

export const nonDatasetSharingPermissions = {
  CONDITIONS: 'can_manage_conditions',
  NOTIFY: 'can_notify',
  SETTINGS: 'can_configure_settings',
  VISIBILITY: 'can_change_visibility',
  COLLECTIONS: 'can_manage_collections',
  DATASOURCE: 'can_manage_datasource',
  ATTACHMENTS: 'can_manage_attachments',
};

export const datasetManagePermissions = {
  ...datasetSharingPermissions,
  ...nonDatasetSharingPermissions,
};

export const datasetAdminPermissions = {
  AUDIT: 'can_read_audit',
  DESTROY: 'can_destroy',
  ...datasetManagePermissions,
};

export const datasetPermissions = {
  APPROVE: 'can_approve',
  ATTACH: 'can_attach',
  UPDATE: 'can_update',
  INGEST_DATA: 'can_ingest_data',
  ...datasetAdminPermissions,
};

export const datasetOwnerPermissions = {
  SECURITY: 'can_manage_perms',
};

export const datasetPermissionGroups = {
  OWNER: Object.values(datasetPermissions),
  MANAGER: Object.values(datasetPermissions).filter((val) => val !== datasetPermissions.APPROVE),
  REVIEWER: [datasetPermissions.APPROVE],
  EDITOR: [datasetPermissions.UPDATE, datasetPermissions.ATTACH],
  OBSERVER: [],
};

export const datasetPermissionCategories = ['open'];

export default datasetSharingActions;
